import React, { useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Assessment, Visibility } from '@material-ui/icons';
import moment from 'moment';
import { UnidataTable } from '~/components';
import { number, downloadFile } from '~/helpers';
import {
  findOperacaoRadPesquisaPreFaturaGfo,
  recordFiltering,
} from '~/store/modules/operacaoradpesquisaprefaturagfo/actions';

import DetalhePreFatura from './components/DetalhePreFatura';

import OperacaoRadPesquisaPreFaturaGfoForm from './form';

function OperacaoRadPesquisaPreFaturaGfoLista() {

  const dispatch = useDispatch();

  const { profile } = useSelector((state) => state.user);

  const buttons = [];

  const operacaoradpesquisaprefaturagfo = useSelector(
    (state) => state.operacaoradpesquisaprefaturagfo
  );

  const detalhePreFaturaRef = useRef(null);

  const handleUpdate = React.useCallback(async () => {
    await dispatch(recordFiltering(operacaoradpesquisaprefaturagfo.params));
  }, [operacaoradpesquisaprefaturagfo.params]);

  const openWinBaixarArquivo = React.useCallback((url) => {
    downloadFile(url);
  }, []);

  const openWin = React.useCallback((url) => {
    window.open(url, "_blank", "toolbar=yes,scrollbars=yes,resizable=yes,top=1,left=1, fullscreen");
  }, []);

  const historicoPeriodo = React.useCallback((value) => {
    openWinBaixarArquivo(value.cosi_url_aplic_rel_rad_getpdf);
  }, []);


  const status = useMemo(() => [
    { value: 'Aguardando Aprovação Gestor do Órgão', label: '1' },
    { value: 'Aguardando Emissão', label: '0' },
    { value: 'Aguardando Emissão da Fatura', label: '5' },
    { value: 'Aguardando Emissão Pedido de Faturamento', label: '4' },
    { value: 'Aprovado Gestor do Órgão', label: '201' },
    { value: 'Aprovado Gestor do Estado', label: '202' },
    { value: 'Cancelada por Contestação', label: '8' },
    { value: 'Contestação do Gestor do Órgão', label: '2' },
    { value: 'Contestação respondida pela Abastek', label: '3' },
    { value: 'Contestação do Gestor do Estado', label: '302' },
    { value: 'Contestação do Gestor do Estado respondida pela Abastek', label: '303' },
    { value: 'Fatura enviada para Órgão', label: '6' },
    { value: 'Fatura Paga', label: '7' },
    { value: 'Gestor do Estado Selecionou para Geração do Faturamento', label: '203' },
    { value: 'Vencida', label: '100' },
  ], []);


  const header = useMemo(() => [
    {
      id: 'fatu_codigo',
      label: 'Pré-fatura',
      align: 'right',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'fatu_periodo',
      label: 'Período',
      align: 'center',
    },
    {
      id: 'fatu_status_str',
      label: 'Status',
      align: 'center',
      converter: status,
      filter: {
        type: 'select',
        options: status,
      },
    },
    // {
    //   id: 'fatu_status_str',
    //   label: 'Status',
    //   align: 'center',
    // },
    {
      id: 'fatu_valor_servico',
      label: 'Valor do Serviço (R$)',
      align: 'right',
      formatted: (value) => number(value, 2),
    },
    {
      id: 'fatu_valor_nota_fiscal',
      label: 'Valor Nota Fiscal (R$)',
      align: 'right',
      formatted: (value) => number(value, 2),
    },
    {
      id: 'fatu_total_retencao',
      label: 'Total das retenções (R$)',
      align: 'right',
      formatted: (value) => number(value, 2),
    },
    {
      id: 'usua_nome_gestor_validacao',
      label: 'Aprovado por',
      align: 'left',
    },
    {
      id: 'fatu_datahora_validacao_gestor',
      label: 'Aprovado em',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),
    },
    {
      id: 'fatu_nota_fiscal',
      label: 'Nota Fiscal',
      align: 'right',
    },
    {
      id: 'fatu_data_pagamento',
      label: 'Pago em',
      align: 'center',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY') : '-'),
    },
  ], []);

  const headerbuttons = useMemo(() => [
    buttons.push({
      title: 'Detalhe da Pré-fatura',
      action: (value) => detalhePreFaturaRef.current.handleToggleModal(value),
      icon: <Visibility />,
    }),

    buttons.push({
      title: 'Dados do Período',
      action: (value) => historicoPeriodo(value),
      icon: <Assessment />,
    }),
  ]);

  return (
    <>
      <h4>
        {profile.glousuarioorgacodigo} - {profile.glousuarioorganome}
      </h4>

      <UnidataTable
        create={false}
        delete={false}
        update={false}
        fixed
        header={header}
        form={OperacaoRadPesquisaPreFaturaGfoForm}
        find={findOperacaoRadPesquisaPreFaturaGfo}
        redux={operacaoradpesquisaprefaturagfo}
        read={recordFiltering}
        actions={buttons}
        detach="fatu_codigo"
      />

      <DetalhePreFatura ref={detalhePreFaturaRef} update={() => handleUpdate()} name="teste" />
    </>
  );
}

export default OperacaoRadPesquisaPreFaturaGfoLista;
